import { useController } from 'react-hook-form'

import { TextField, TextFieldProps } from './TextField'

export type SelectProps = TextFieldProps
export const Select = (props: SelectProps) => (
  <TextField {...props} variant={props.variant || 'standard'} select={true} />
)

export type CSelectProps = SelectProps & {
  name: string
}

export const CSelect = (props: CSelectProps) => {
  const { name, ...selectProps } = props
  const { field, fieldState } = useController({ name })
  const { ref, ...fieldProps } = field

  const value = field.value === undefined ? '' : field.value

  return (
    <Select
      slotProps={{
        ...props.slotProps,
        select: {
          ...props.slotProps?.select,
        },
      }}
      {...selectProps}
      {...fieldProps}
      value={value}
      inputRef={ref}
      error={!!fieldState.error}
      helperText={fieldState.error ? fieldState.error.message : selectProps.helperText}
      onBlur={field.onBlur}
    />
  )
}
